<template>
  <v-img
    v-on:load="imageLoaded"
    class="mx-auto"
    :src="filesrc"
    :max-width="maxPxSize"
  >
    <span v-if="overlaytext && loaded">
      <h1 class="text-right mt-2 mr-10 overlaytext">
        {{ overlaytext }}
      </h1>
    </span>
  </v-img>
  <component class="mt-6 text-center" :is="textsize">{{ text }}</component>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

const loaded = ref(false);

const props = withDefaults(
  defineProps<{
    text: string;
    illustration?: "1" | "2" | "3";
    imgsrc?: string;
    size?: "xs" | "small" | "medium" | "large";
    textsize?: "p" | "h1" | "h2" | "h3";
    overlaytext?: string;
  }>(),
  {
    illustration: "1",
    size: "medium",
    textsize: "p",
  }
);

const filesrc = computed(() => {
  if (props.imgsrc) {
    return props.imgsrc;
  } else {
    switch (props.illustration) {
      case "1":
        return "/assets/people-illustration-1.svg";
      case "2":
        return "/assets/people-illustration-2.svg";
      case "3":
        return "/assets/people-illustration-3.svg";
      default:
        console.error("wrong asset");
        return "";
    }
  }
});

const maxPxSize = computed(() => {
  switch (props.size) {
    case "xs":
      return "75px";
    case "small":
      return "150px";
    case "medium":
      return "250px";
    case "large":
      return "500px";
    default:
      console.error("wrong asset");
      return "";
  }
});

function imageLoaded(): void {
  loaded.value = true;
}
</script>

<style>
.overlaytext {
  font-size: 64px;
  font-weight: 700;
  color: var(--tangerine);
}
</style>
